import React from 'react';
import { Section } from './ui/Section';
export function SocialProof() {
  const testimonials = [{
    quote: 'Llevo 3 semanas y he perdido 4 cm de perímetro. Lo más increíble es que no he pasado ni un solo día con hambre.',
    name: 'María G., 38 años',
    location: 'Madrid'
  }, {
    quote: 'El pan de semillas del Tomo 2 lo hago cada domingo. Mi marido lleva semanas comiéndolo y ni sabe que no lleva trigo.',
    name: 'Carmen R., 44 años',
    location: 'Sevilla'
  }, {
    quote: 'El bajón de las 3 de la tarde desapareció en menos de 2 semanas. Algo que llevaba 10 años sufriendo.',
    name: 'Laura M., 35 años',
    location: 'Barcelona'
  }, {
    quote: 'Soy cocinera profesional y las recetas del Tomo 3 son de una calidad técnica impresionante. Mi carbonara de konjac ya es el plato favorito de mi marido.',
    name: 'Rocío A., 37 años',
    location: 'Cocinera · Córdoba'
  }, {
    quote: 'Soy de Sevilla. El pan es sagrado aquí. Mi familia lleva 3 semanas con el mollete del sistema y ninguno sabe que no es pan normal.',
    name: 'Antonio J., 52 años',
    location: 'Empresario · Sevilla'
  }, {
    quote: 'La Guía Social me cambió la vida. Ahora voy a cualquier boda sin estrés. Sé exactamente qué pedir. Me siento libre por primera vez.',
    name: 'Marta S., 33 años',
    location: 'Abogada · Bilbao'
  }];
  return <Section data-id="element-166" data-mp="1z7mr82f20inf">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-167" data-mp="1z6uyczcucz0u">
        Personas que ya están sin renunciar a la mesa
      </h2>
      <p className="text-center text-brand-secondary font-semibold mb-10 font-body text-sm md:text-base" data-id="element-168" data-mp="280gb6d5g467m">
        Y ninguna dejó de comer lo que le gusta.
      </p>

      <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto" data-id="element-169" data-mp="2hyw32icarji6">
        {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-border rounded-2xl p-5 shadow-card flex flex-col" data-id="element-170" data-mp="sjzcmlvukq7d" data-mpi={i}>
            <div className="text-brand-secondary mb-2.5 tracking-wide text-sm" data-id="element-171" data-mp="nm6ac3xo0gcd">
              ★★★★★
            </div>
            <p className="font-body text-brand-text text-sm leading-relaxed mb-3 flex-1" data-id="element-172" data-mp="1dav4o9a5q4zy">
              "{t.quote}"
            </p>
            <div data-id="element-173" data-mp="1hd828aer2wln">
              <div className="font-heading text-brand-title font-semibold text-sm" data-id="element-174" data-mp="1ma88omfii1da">
                {t.name}
              </div>
              <div className="text-brand-textMuted text-xs font-body" data-id="element-175" data-mp="1r9l0lll8pymq">
                {t.location}
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}